import { URL } from 'url';

export default function getMergedDest(state, nextState, loginOpts) {
  const { tenantLoginUrl, useGlobalLogin } = loginOpts;
  const { location: { search, pathname } } = nextState;
  const currentUrl = state.getIn(['browser', 'location', 'origin']);

  const dest = `${pathname}${search || ''}`;
  const mergedDest = `${currentUrl}${dest}`;
  if (useGlobalLogin) return mergedDest;
  try {
    const parsedTenant = new URL(tenantLoginUrl);
    if (!(currentUrl === `${parsedTenant.protocol}//${parsedTenant.host}`)) return mergedDest;
  } catch (err) {
    // Invalid or undefined tenantLoginUrl will throw an error under new URL API.
    return dest;
  }
  return dest;
}
